import React, { useState } from "react";

export default function Unit(props) {
  let [metrics, setMetrics] = useState("celsius");

  function changeToFahrenheit(event) {
    event.preventDefault();
    setMetrics("fahrenheit");
  }

  function callFahrenheit() {
    return (props.metric * 9) / 5 + 32;
  }

  function changeToCelsius(event) {
    event.preventDefault();
    setMetrics("celsius");
  }

  if (metrics === "celsius") {
    return (
      <li className="temperature">
        {" "}
        {Math.round(props.metric)}
        <span id="metr">
          °C|
          <a href="https://www.google.com/" onClick={changeToFahrenheit}>
            {" "}
            °F
          </a>
        </span>
      </li>
    );
  } else {
    return (
      <li className="temperature">
        {" "}
        {Math.round(callFahrenheit())}{" "}
        <span id="metr">
          <a href="https://www.google.com/" onClick={changeToCelsius}>
            °C
          </a>
          |°F
        </span>
      </li>
    );
  }
}
